import React, { useContext, useEffect, useState } from 'react';
import { Loan, Task, TaskResponse, TaskState } from 'gql/graphql';
import { useCreateResponseTask, useUpdateTaskState } from 'services/task/mutations';
import { ModuleKeys } from 'services/task/modules-keys.constanst';
import { SubmitContext, TaskContext } from '../EntityGuarantorCreation';
import { useCreateEntity } from 'services/entity/mutations';
import { LoanContext, TasksContext } from 'scenes/Private/Dashboard/Dashboard';
import moment from 'moment';
import ErrorBox from 'components/Atoms/Alerts/ErrorBox';
import alertIcon from 'assets/images/alert-triangle.svg';
import { DATE_FORMAT } from '@common/utils/constants/dates.constanst';
import { Button } from 'components/Atoms/Buttons';

interface Step2Props {
  ownerships: any[];
  entity?: { key: string; name: string };
  step2Confirm?: any;
  newOwner: any;
  responseStep1: TaskResponse;
  messageErrorDisabled?: string;
  isReadOnly?: boolean;
}
const ButtonSubmit = ({
  ownerships,
  entity,
  step2Confirm,
  newOwner,
  responseStep1,
  messageErrorDisabled,
  isReadOnly,
}: Step2Props) => {
  const task: Task | any = useContext(TaskContext);
  const loan: Loan | any = useContext(LoanContext);
  const tasks = useContext(TasksContext);
  const entityDocsTask = tasks?.find((item) => item.key === ModuleKeys.ENTITY_DOCS);
  const onSubmitParent: { step?: number; active?: boolean } | any =
    useContext(SubmitContext);

  const { fetching, execute: createResponseTask } = useCreateResponseTask();
  const { fetching: fetchingEntity, execute: createEntity } = useCreateEntity();
  const { execute: updateTaskState } = useUpdateTaskState();
  const [showErrorBox, setShowErrorBox] = useState(false);

  useEffect(() => {
    if (onSubmitParent.active && onSubmitParent.step === 2) submitOwnerships();
  }, [onSubmitParent]);

  const getTotal = () =>
    ownerships
      .reduce(
        (total: number, ownership: any) => total + ownership.ownership,
        0
      );

  useEffect(() => {
    if (!step2Confirm || getTotal() === 100) setShowErrorBox(false);
  }, [step2Confirm, getTotal()]);

  const handleDisabledClick = () => {
    if (!isReadOnly && getTotal() !== 100 && !step2Confirm) {
      setShowErrorBox(true);
    }
  };

  const submitOwnerships = async () => {
    await Promise.all([
      createResponseTask({
        task: task._id,
        key: `complete-ownerships`,
        label: `Add 100% ownership to submit`,
        step: 3,
        metadata: {},
        state: TaskState.Approved
      }),
      createEntity({
        _id:
          responseStep1.label === 'Existing entity'
            ? responseStep1.key
            : undefined,
        name: entity?.name || `Entity created on ${moment().format(DATE_FORMAT)}`,
        loans: [loan._id],
        task: task._id
      })
    ]);
    if (entityDocsTask?.state === TaskState.ComingSoon) {
      await updateTaskState({
        updateTaskStateInput: {
          _id: entityDocsTask._id,
          key: ModuleKeys.ENTITY_DOCS,
          state: TaskState.Draft
        }
      });
    }
  };

  const disabledSubmit = getTotal() !== 100 && !step2Confirm || isReadOnly || fetching || fetchingEntity || newOwner;

  return (
    <>
      <div style={{ position: 'relative', width: '100%' }}>
        <Button.Primary
          onClick={submitOwnerships}
          onClickWhenDisabled={handleDisabledClick}
          loading={fetching || fetchingEntity}
          disabled={disabledSubmit}
        >
          {step2Confirm
            ? 'Confirm ownership'
            : getTotal() !== 100
              ? 'Add 100% ownership to submit'
              : 'Create entity and complete profiles'
          }
        </Button.Primary>

        {showErrorBox && messageErrorDisabled && (
          <ErrorBox text={messageErrorDisabled} img={alertIcon} className='mt-10' />
        )}
      </div>
    </>
  );
};
export default ButtonSubmit;
